import type { CSSProperties } from 'react';

import type { EditorCollectionItemDragData } from '@/components/blocks/editor/collection/collection-dnd';
import type { CollectionCardConfig, CollectionItem } from '@/lib/blocks/collection/blocks';
import type { CollectionMediaLayout } from '@/lib/blocks/collection/media-layout';
import { CollectionCard } from '../../../collection/collection-card';
import type { CollectionCardSideBySideMode } from '../../../collection/types';
import { makeEditorRenderField } from '../item-fields';
import { SortableCardBody, SortableCollectionCardRoot } from './card-shell';

type SortableCollectionCardProps = {
  item: CollectionItem;
  totalCount: number;
  sortIndex: number;
  collectionSortableGroup: string;
  collectionItemDragData: EditorCollectionItemDragData;
  cardConfig: CollectionCardConfig;
  mediaLayout?: CollectionMediaLayout;
  sideBySideMode?: CollectionCardSideBySideMode;
  paddingClassName?: string;
  contentPaddingClassName?: string;
  cardStyle?: CSSProperties;
  disabled?: boolean;
  actionsDisabled?: boolean;
  onUpdate: (updated: CollectionItem, commit?: boolean) => void;
  onDelete: () => void;
  onDuplicate: () => void;
  onSelectionChange?: (selected: boolean) => void;
  primarySelected?: boolean;
  sortableId?: string;
};

export function SortableCollectionCard({
  item,
  totalCount,
  sortIndex,
  collectionSortableGroup,
  collectionItemDragData,
  cardConfig,
  mediaLayout,
  sideBySideMode,
  paddingClassName,
  contentPaddingClassName,
  cardStyle,
  disabled,
  actionsDisabled,
  onUpdate,
  onDelete,
  onDuplicate,
  onSelectionChange,
  primarySelected,
  sortableId,
}: SortableCollectionCardProps) {
  return (
    <SortableCollectionCardRoot
      item={item}
      totalCount={totalCount}
      sortIndex={sortIndex}
      collectionSortableGroup={collectionSortableGroup}
      collectionItemDragData={collectionItemDragData}
      disabled={disabled}
      actionsDisabled={actionsDisabled}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      onSelectionChange={onSelectionChange}
      primarySelected={primarySelected}
      outerClassName="h-full min-w-0"
      sortableId={sortableId}
    >
      <SortableCardBody paddingClassName={paddingClassName} cardStyle={cardStyle}>
        <CollectionCard
          item={item}
          cardConfig={cardConfig}
          mediaLayout={mediaLayout}
          sideBySideMode={sideBySideMode}
          contentPaddingClassName={contentPaddingClassName}
          renderField={makeEditorRenderField(item, onUpdate, Boolean(disabled))}
        />
      </SortableCardBody>
    </SortableCollectionCardRoot>
  );
}
